export const getCssTokenValue = (tokenName: string): string => {
  if (typeof document === 'undefined') return '';
  return getComputedStyle(document.documentElement).getPropertyValue(tokenName).trim();
};
